import React, { useState } from 'react';
// logic
import ticketService from 'modules/emergencies/ticketService';
// components
import { FormButton } from '../ui/buttons/FormButton';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import {
  ModalContainer,
  CloseButtonContainer,
  ModalBody,
  ModalFooter,
  ModalFormContainer,
  ModalHeader,
  ModalHeaderInnerContainer,
  ModalHeaderMainText,
  ModalHeaderSecondaryText,
  ModalBoldText,
  ModalRegularText,
  CheckboxInputContainer,
  RadioInputsContainer,
} from './modalComponents';
import CheckBoxLabel from '../ticketForm/components/CheckBoxLabel';
import { PremiumInput } from '../ui/inputs/customInput';

const t = {
  confirm: 'Cancel ticket',
  back: 'Back',
  title: 'Do you want to cancel this ticket?',
};
export const CancelTicketModal = ({ ok, cancel, cancelTicketModalProps }) => {
  const { ticket = {} } = cancelTicketModalProps;

  const goBack = (e) => {
    e.preventDefault();
    cancel();
  };
  const formattedTicketId = ticketService.utils.getFormatedId(ticket.id);

  const availableReasons = {
    LATE: 'Late response',
    ALREADY_COVERED: 'Service covered by another provider',
    NOT_NEEDED: 'I no longer need the service',
    OUT_OF_SCOPE: 'Out of scope',
    OTHER: 'Other reason',
  };
  const [reason, setReason] = useState(Object.keys(availableReasons)[0]);
  const [text, setText] = useState('');
  return (
    <ModalContainer>
      <ModalBody>
        <ModalHeader>
          <ModalHeaderInnerContainer>
            <ModalHeaderSecondaryText>{`Ticket ID. ${formattedTicketId}`}</ModalHeaderSecondaryText>
            <ModalHeaderMainText>{t.title}</ModalHeaderMainText>
          </ModalHeaderInnerContainer>
        </ModalHeader>
        <ModalFormContainer>
          <ModalRegularText>Please select the reason for cancellation:</ModalRegularText>
          <RadioInputsContainer>
            {Object.keys(availableReasons).map((key) => (
              <CheckboxInputContainer key={key} onClick={() => setReason(key)}>
                {key === reason ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <circle cx="10" cy="10" r="10" fill="#2396DC" />
                    <circle cx="10" cy="10" r="4" fill="white" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                  >
                    <circle cx="10" cy="10" r="9.5" fill="white" stroke="#E2E8EE" />
                  </svg>
                )}

                <CheckBoxLabel>{availableReasons[key]}</CheckBoxLabel>
              </CheckboxInputContainer>
            ))}
          </RadioInputsContainer>
          <PremiumInput
            width={'100%'}
            type="text"
            label={'Cancellation details'}
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
          <ModalBoldText>This action cannot be undone.</ModalBoldText>
        </ModalFormContainer>
      </ModalBody>
      <ModalFooter>
        <FormButton variant="ghost" onClick={goBack}>
          {t.back}
        </FormButton>
        <FormButton
          onClick={() =>
            ok({
              reason,
              text,
            })
          }
        >
          {t.confirm}
        </FormButton>
      </ModalFooter>
      <CloseButtonContainer onClick={goBack}>
        <CloseIcon />
      </CloseButtonContainer>
    </ModalContainer>
  );
};
